import { ProfileItem } from "PFApp/components/profile_item";
import { fetchProfilesOptions, ProfilesOptionsParams } from "PFCore/services/profile";
import { BasicProfile, Collection, Id, Option } from "PFTypes";
import { ReactNode } from "react";

export type ProfileOptionOriginal = BasicProfile & { text: string };

export type ProfilesOptionsFetcherConfig = Pick<
  ProfilesOptionsParams,
  "policyName" | "profileVisibility" | "perPage"
> & {
  excludeProfileId?: Id;
  renderDisplayElement?: ((profile: ProfileOptionOriginal) => ReactNode) | false;
  getValue?: (profile: ProfileOptionOriginal) => string;
  getDisabled?: (profile: ProfileOptionOriginal) => boolean;
};

const defaultRenderDisplayElement = (profile: ProfileOptionOriginal) => <ProfileItem profile={profile} />;

export const buildProfilesOptionsFetcher =
  ({
    excludeProfileId,
    renderDisplayElement = defaultRenderDisplayElement,
    getValue = (profile) => profile.text,
    getDisabled,
    ...params
  }: ProfilesOptionsFetcherConfig = {}) =>
  async ({
    searchTerm,
    ids
  }: {
    searchTerm?: string;
    ids?: Id[];
  }): Promise<Collection<Option<ProfileOptionOriginal>[]>> => {
    const data = await fetchProfilesOptions({ ...params, term: searchTerm, value: ids });

    return {
      ...data,
      entries: data.entries
        .filter((profile) => ids || excludeProfileId === undefined || profile.id !== excludeProfileId)
        .map((profile) => ({
          id: profile.id,
          value: getValue(profile),
          displayElement: renderDisplayElement === false ? undefined : renderDisplayElement(profile),
          disabled: getDisabled?.(profile),
          original: profile
        }))
    };
  };
